import React from 'react';
import usePageview from '../hooks/usePageview';
import setWrappedComponent from '../utils/react/setWrappedComponent';
/**
 * @param {React.ComponentType} WrappedComponent
 * @param {object} [options]
 * @param {string} [options.path] - The path portion of a URL
 * @param {string|string[]} [options.trackerNames] - Google analytics tracker Name
 * @param {string} [options.title=document.title] - Page title
 */
export default function withPageview(WrappedComponent, options = {}) {
  function WithPageview(props) {
    usePageview(options);
    return <WrappedComponent {...props} />;
  }

  setWrappedComponent(WithPageview, WrappedComponent);

  return WithPageview;
}